import { gql } from '@apollo/client'

export const UPDATE_TENANT_TABLE_COLUMN_VISIBILITY = gql`
  mutation UpdateTenantTableColumnVisibility(
    $tableId: String!
    $hiddenColumns: [String!]!
  ) {
    updateTenantTableColumnVisibility(
      tableId: $tableId
      hiddenColumns: $hiddenColumns
    ) {
      tableId
      tenantHiddenColumns
      userHiddenColumns
      effectiveHiddenColumns
    }
  }
`
